<template>
  <div class="mx-auto">
    <TitleWrapper
      :filter-option="false"
      title="GENERAL_SETTINGS"
      tooltip-title="GENERAL_SETTINGS"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <!-- <ValidationObserver v-slot="{ invalid, handleSubmit }" tag="div"> -->
    <div
      class="bg-white minHeightMainContent mt-2 md:mt-5 pt-7 px-3 md:px-7 border rounded-t-lg border-border-color-lighter"
    >
      <div v-if="isLoading" class="mt-28">
        <Loader :content="true" />
      </div>
      <div v-else>
        <InputFieldWrapper>
          <UiMultiSelect
            v-model="generalSettings.allowed_timezones"
            :options="timeZoneList"
            title="ALLOWED_TIMEZONE"
            :already-selected="permittedTimeZones"
            label="title"
            :search-enable="true"
            :is-locked-from-upper-level="generalSettings.is_locked_up_allowed_timezones"
            :lock-value="generalSettings.is_locked_allowed_timezones"
            :disabled="
              generalSettings.is_locked_up_allowed_timezones ||
              generalSettings.is_locked_allowed_timezones
            "
            :show-lock="true"
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'allowed_timezones')
              }
            "
            @receiveList="
              updatedPermittedLists(generalSettings.allowed_timezones, permittedTimeZones)
            "
          />
          <UiSingleSelect
            :key="`default-timezone-${forceRender}`"
            v-model="generalSettings.default_timezone_region"
            title="DEFAULT_TIMEZONE"
            label="title"
            :options="timezoneOptions"
            reduce="zone"
            rules="required"
            :is-locked-from-upper-level="generalSettings.is_locked_up_default_timezone"
            :lock-value="generalSettings.is_locked_default_timezone"
            :show-lock="true"
            :disabled="
              generalSettings.is_locked_up_default_timezone ||
              generalSettings.is_locked_default_timezone
            "
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'default_timezone')
              }
            "
          />

          <UiMultiSelect
            v-model="generalSettings.allowed_currencies"
            :options="currenciesList"
            :already-selected="permittedCurrencies"
            title="ALLOWED_CURRENCIES"
            label="title"
            :search-enable="true"
            :lock-value="generalSettings.is_locked_allowed_currencies"
            :is-locked-from-upper-level="generalSettings.is_locked_up_allowed_currencies"
            :disabled="
              generalSettings.is_locked_allowed_currencies ||
              generalSettings.is_locked_up_allowed_currencies
            "
            :show-lock="true"
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'allowed_currencies')
              }
            "
            @receiveList="
              updatedPermittedLists(generalSettings.allowed_currencies, permittedCurrencies)
            "
          />
          <UiSingleSelect
            :key="`default-currency-${forceRender}`"
            v-model="generalSettings.default_currency"
            label="title"
            reduce="id"
            :options="currencyOptions"
            title="DEFAULT_CURRENCY"
            rules="required"
            :is-locked-from-upper-level="generalSettings.is_locked_up_default_currency"
            :lock-value="generalSettings.is_locked_default_currency"
            :disabled="
              generalSettings.is_locked_up_default_currency ||
              generalSettings.is_locked_default_currency
            "
            :show-lock="true"
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'default_currency')
              }
            "
          />

          <UiMultiSelect
            v-model="generalSettings.allowed_countries"
            :options="countriesList"
            title="ALLOWED_COUNTRIES"
            :search-enable="true"
            :already-selected="permittedCountries"
            label="title"
            :lock-value="generalSettings.is_locked_allowed_countries"
            :is-locked-from-upper-level="generalSettings.is_locked_up_allowed_countries"
            :disabled="
              generalSettings.is_locked_allowed_countries ||
              generalSettings.is_locked_up_allowed_countries
            "
            class="w-full"
            :show-lock="true"
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'allowed_countries')
              }
            "
            @receiveList="
              updatedPermittedLists(generalSettings.allowed_countries, permittedCountries)
            "
          />
          <UiSingleSelect
            v-model="generalSettings.default_country"
            :options="countryOptions"
            title="DEFAULT_COUNTRY"
            label="title"
            reduce="id"
            rules="required"
            :lock-value="generalSettings.is_locked_default_country"
            :is-locked-from-upper-level="generalSettings.is_locked_up_default_country"
            :disabled="
              generalSettings.is_locked_default_country ||
              generalSettings.is_locked_up_default_country
            "
            :show-lock="true"
            @updateLockValue="
              (e) => {
                updateLockValue(e, 'default_country')
              }
            "
          />
          <UiTimePicker
            v-if="currentCampusScope"
            v-model="generalSettings.campus_starts_at_time"
            :utc-time-zone="generalSettings.default_timezone"
            title="Start Time"
            type="time"
            name="Start Time"
            rules="required"
          />
          <UiTimePicker
            v-if="currentCampusScope"
            v-model="generalSettings.campus_ends_at_time"
            :utc-time-zone="generalSettings.default_timezone"
            title="End Time"
            type="time"
            name="End Time"
            rules="required"
          />
        </InputFieldWrapper>
        <div class="pb-5 md:pb-0">
          <button
            class="mb-5 mt-5 md:mt-10 focus:outline-none focus:shadow-md ltr:text-base rtl:text-sm text-white font-rubik flex w-full md:w-40 py-2 justify-center primary-button"
            :disabled="isLoading"
            @click.prevent="updateSettings()"
          >
            {{ $t('dashboard.Save') }}
          </button>
        </div>
      </div>
    </div>
    <!-- </ValidationObserver> -->
  </div>
</template>

<script>
import TitleWrapper from '@components/TitleWrapper.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
// import { ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import { mapState, mapActions } from 'vuex'
import { getPermittedCountries } from '@src/utils/settings/settings-utils'
import { objectDeepCopy, getCountriesList } from '@src/utils/generalUtil'
import { getTimeZoneList } from '@utils/moment.util'
import Loader from '@components/BaseComponent/Loader.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
import UiTimePicker from '@components/UiElements/UiTimePicker.vue'
import { isEmpty, isArray } from 'lodash'
export default {
  components: {
    TitleWrapper,
    UiSingleSelect,
    UiMultiSelect,
    // ValidationObserver,
    Loader,
    InputFieldWrapper,
    UiTimePicker,
  },
  page: {
    title: 'System Settings | Site Settings',
    meta: [
      {
        name: 'description',
        content: 'Site Settings',
      },
    ],
  },
  data() {
    return {
      timeZoneList: getTimeZoneList(),
      countriesList: getCountriesList(),
      permittedTimeZones: [],
      permittedCountries: [],
      permittedCurrencies: [],
      currencyOptions: [],
      countryOptions: [],
      generalSettings: null,
      currenciesList: null,
      isLoading: false,
      forceRender: 0,
    }
  },
  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope,
    }),
    timezoneOptions() {
      return isEmpty(this.permittedTimeZones) ? this.timeZoneList : this.permittedTimeZones
    },
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getSettings()
      },
    },
    'generalSettings.allowed_timezones': {
      immediate: true,
      deep: true,
      handler(value) {
        this.onAllowedTimezonesChange(value)
      },
    },
    'generalSettings.allowed_currencies': {
      immediate: true,
      deep: true,
      handler(value) {
        if (!value) return
        this.onAllowedCurrenciesChange(value)
      },
    },
    'generalSettings.allowed_countries': {
      immediate: true,
      deep: true,
      handler(value) {
        if (!value) return
        this.onAllowedCountriesChange(value)
      },
    },
  },
  created() {
    this.generalSettings = objectDeepCopy(this.$store.state.layout.generalSettings)
    this.currenciesList = objectDeepCopy(
      this.$store.state.settings.siteSettingsDefaults.currenciesList,
    )
  },
  mounted() {
    if (this.currentCampusScope) this.getSettings()
    else this.setSettingsDefaultData()
  },
  methods: {
    onAllowedTimezonesChange(value) {
      if (isArray(value)) {
        const zones = value.map((timezone) => timezone.zone).filter(Boolean)
        this.permittedTimeZones = this.timeZoneList.filter((t) => zones.includes(t.zone))
      } else {
        this.permittedTimeZones = []
      }
      const zones = this.permittedTimeZones.map((timezone) => timezone.zone)
      if (zones.length && !zones.includes(this.generalSettings.default_timezone_region)) {
        this.generalSettings.default_timezone_region = zones[0]
      }
      this.forceRender += 1
    },
    onAllowedCurrenciesChange(value) {
      if (!value) return
      const selected = isArray(value) ? value : []
      if (!selected.length) {
        this.permittedCurrencies = []
      } else if (typeof selected[0] === 'object') {
        this.permittedCurrencies = selected.filter((currency) => currency)
      } else {
        const ids = selected.filter((id) => id)
        this.permittedCurrencies = Array.isArray(this.currenciesList)
          ? this.currenciesList.filter((c) => c && ids.includes(c.id))
          : []
      }
      this.currencyOptions = this.permittedCurrencies.length
        ? this.permittedCurrencies
        : this.currenciesList
        ? this.currenciesList.slice()
        : []
      if (this.permittedCurrencies.length === 1 && this.generalSettings) {
        const onlyCurrency = this.permittedCurrencies[0]
        this.generalSettings.default_currency = onlyCurrency.id
      }
      if (this.generalSettings && !this.generalSettings.default_currency) {
        const fallbackIds = this.currencyOptions
          .filter((currency) => currency)
          .map((currency) => currency.id)
        this.generalSettings.default_currency = fallbackIds.length ? fallbackIds[0] : null
      }
      this.forceRender += 1
    },
    onAllowedCountriesChange(value) {
      if (!value) return
      const selected = isArray(value) ? value : []
      if (!selected.length) {
        this.permittedCountries = []
      } else if (typeof selected[0] === 'object') {
        this.permittedCountries = selected.filter((country) => country)
      } else {
        const ids = selected.filter((id) => id !== null)
        this.permittedCountries = this.countriesList.filter((country) => ids.includes(country.id))
      }
      this.countryOptions = this.permittedCountries.length
        ? this.permittedCountries
        : this.currenciesList
        ? this.countriesList.slice()
        : []
      if (this.permittedCountries.length === 1 && this.generalSettings) {
        const onlyCountry = this.permittedCountries[0]
        this.generalSettings.default_country = onlyCountry.id
      }
      if (this.generalSettings && !this.generalSettings.default_country) {
        const fallbackIds = this.countryOptions
          .filter((country) => country)
          .map((country) => country.id)
        this.generalSettings.default_country = fallbackIds.length ? fallbackIds[0] : null
      }
      this.forceRender += 1
    },
    updatedPermittedLists(allowedList = [], permittedList = []) {
      allowedList.forEach((allowItem) => {
        let isExist = permittedList.some((permittedItem) => {
          return permittedItem.id === allowItem.id
        })
        if (!isExist && typeof allowItem === 'object') {
          permittedList.push(allowItem)
        }
      })
    },
    updateSettings() {
      this.transformPayload().then(() => {
        if (!this.currentCampusScope) {
          delete this.generalSettings.campus_starts_at_time
          delete this.generalSettings.campus_ends_at_time
        }
        this.updateFeaturesGeneralSettings(this.generalSettings)
          .then((res) => {
            this.generalSettings = res
            this.$store.commit('toast/NEW', {
              message: 'Settings Update Successfully',
              type: 'success',
            })
          })
          .finally(() => {
            this.getSettings()
          })
      })
    },

    getSettings() {
      this.isLoading = true
      this.getFeaturesGeneralSettings().then((res) => {
        this.generalSettings = objectDeepCopy(res)
        this.setSettingsDefaultData()
        this.isLoading = false
      })
    },
    transformPayload() {
      return new Promise((resolve, reject) => {
        this.setDefaultTimezoneByRegion(this.generalSettings.default_timezone_region)
        this.reduceAllowedItems('allowed_currencies')
        this.reduceAllowedItems('allowed_countries')
        resolve()
      })
    },
    setDefaultTimezoneByRegion(defaultTimezone) {
      const match = this.timeZoneList.find((t) => t && t.zone === defaultTimezone)
      this.generalSettings.default_timezone = match ? match.timeDifference : null
    },
    reduceAllowedItems(allowedList = '', key = 'id') {
      const allowedCountriesList = this.generalSettings[allowedList]
      if (!isArray(allowedCountriesList)) {
        this.generalSettings[allowedList] = []
        return
      }
      this.generalSettings[allowedList] = allowedCountriesList.map((item) => {
        return item[key]
      })
    },

    updateLockValue(e, key) {
      this.generalSettings[`is_locked_${key}`] = e
    },
    setSettingsDefaultData() {
      this.$store.commit('settings/SET_ALLOWED_COUNTRIES', this.permittedCountries)
    },
    ...mapActions('settings', ['updateFeaturesGeneralSettings', 'getFeaturesGeneralSettings']),
  },
}
</script>
